import React from 'react';
import { useSignout } from '../services';

const SignOut = () => {
  useSignout(true);
  return <></>;
};

export default SignOut;
